import { SecureRoute } from '@okta/okta-react';
import React, { FC } from 'react';
import { Redirect, Switch, useRouteMatch } from 'react-router';
import { ProjectId } from 'api/models';
import { Project } from 'api/project';
import { RoutePaths } from 'constant';
import { getProjectTaskListUrl } from 'utils/urls';
import { ProjectTaskBoardPage } from './board';
import { ProjectTaskListPage } from './list';

export const ProjectTasksPage: FC<{
  project: Project;
}> = ({ project }) => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <SecureRoute path={RoutePaths.projectTaskList} exact>
        <ProjectTaskListPage project={project} />
      </SecureRoute>
      <SecureRoute path={RoutePaths.projectTaskBoard} exact>
        <ProjectTaskBoardPage project={project} />
      </SecureRoute>
      <SecureRoute path={path} exact>
        <Redirect to={getProjectTaskListUrl(ProjectId(project.projectId))} />
      </SecureRoute>
    </Switch>
  );
};
